import { Component, OnInit } from '@angular/core';
import {OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcSigninService} from 'exc-signin';
import {ExcTranslation} from 'exc-core';

@Component({
  selector: 'app-modal-plan-audit',
  templateUrl: './modal-plan-audit.component.html',
  styles: []
})
export class ModalPlanAuditComponent extends ExcTranslation implements OnInit {
  datepickerConfig: any = {
    enableTime: false,
    altFormat: 'd.m.Y',
    minDate: new Date().setHours(0, 0, 0, 0)
  };
  planDate;
  constructor(public overlayConfig: OverlayConfig, public overlayRef: OverlayRef, private excSec: ExcSigninService) {
    super();
    const _self = this;
  }

  ngOnInit() {
    const _self = this;
    _self.planDate = _self.overlayConfig.data.PlanData ? new Date(_self.overlayConfig.data.PlanData) : null;
  }
  plan() {
    const _self = this;
    _self.overlayRef.close({proceed: true, planDate: _self.planDate});
  }
}
